<template>
  <div class="home">
    <HeroSlider :sliderImages="sliderImages" :buttonInfo="buttonInfo" />
    <BookSuiteForm />
    <!-- <Gala /> -->
  </div>
</template>

<script>
import BookSuiteForm from "@/components/Home/BookSuiteForm";
import HeroSlider from "@/components/HeroSlider";
import { homeImages } from "@/data/homeSliderData";
// import Gala from "@/components/Home/Gala";

export default {
  name: "Home",
  components: {
    BookSuiteForm,
    HeroSlider,
    // Gala,
  },
  data() {
    return {
      sliderImages: homeImages,
      buttonInfo: {
        text: "View Online Suites Availability",
        link: "https://flex2.seasonshare.com/texasrangers_suites/purchase_seats?purchaseSeatTab=find_games",
      },
    };
  },
};
</script>
